import { formatDate, registerLocaleData } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Afiliacion } from 'src/app/models/afiliacion';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import localeEs from '@angular/common/locales/es';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import * as _moment from 'moment';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DireccionesComponent } from 'src/app/direcciones/direcciones.component';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { general } from './../../models/general';
import { MessageService } from 'primeng/api';
import { ciudades } from 'src/app/models/ciudades';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

registerLocaleData(localeEs, 'es');

@Component({
  selector: 'app-afiliacion',
  templateUrl: './afiliacion.component.html',
  styleUrls: ['./afiliacion.component.css'],
  providers: [UserService,
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})

export class AfiliacionComponent implements OnInit {
  public grupoAsociados;
  public grupoAsociados2;
  public grupoLaboral;
  public grupoFinanciera;
  public grupoFamiliar;
  public grupoReferenciaFam;
  public grupoReferenciaPer;
  public grupoReferencia;
  public grupoAhorros;
  public grupoAseguradora;
  public grupoBeneficiariosfalle;
  public FormularioAfiliacionWeb;
  public verdadero = false;
  public Loading = false;
  public grupos = new Array();
  public select = new Array();
  public camposSeparadosS: any[] = [];
  public camposSeparadosN: any[] = [];
  public campoFiltrada: ciudades;
  public CiudadNombreFiltrada: any;
  public Afiliacion;
  public autorizacion: any;
  private ip;
  public ciudadesFiltrada = new Array();
  public valor = new Array();
  public SiNo;
  public NombreSiNo = new Array();
  public familiares = [];
  public beneficiarios = [];
  public AfiliacionConfig
  public mobile
  private entidad
  private oficinas: any
  public width
  public paramFam = {}
  public paramBen = {}
  public attrFam = {
    disabled: {
      familiar1: {},
      beneficiario1: {}
    }
  }

  private generalModel

  grupoDocumentos: any;

  actual = environment.actual;
  modulo = environment.entidad[this.actual].moduloAfil
  logo = environment.entidad[this.actual].urlLogo
  urlImg = environment.entidad[this.actual].urlEndPoint + 'docAfiliacion'
  prod = environment.production
  remove: boolean;
  currentYear: any;
  maxDateNac: any;
  ipAddress: any;
  fecexp: any;
  fecnac: any;
  fechaingempresa: any;

  constructor(
    private Servicio: UserService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private _router: Router,
    private messageService: MessageService) {
    this.currentYear = formatDate(new Date(), 'yyyy-MM-dd', 'es');
    let fecha = new Date()
    let año = fecha.getFullYear() - 18
    let mes = fecha.getMonth() + 1
    let dia = fecha.getDate()
    console.log(año + '-' + mes + '-' + dia)
    this.maxDateNac = formatDate(año + '-' + mes + '-' + dia, 'yyyy-MM-dd', 'es');

  }

  ngOnInit(): void {
    if (this.Servicio.GetsessionStorage('token') != '') {
      this.AfiliacionConfig = JSON.parse(this.Servicio.GetsessionStorage('config'));
      if (window.screen.width > 768) {
        this.mobile = true;
        this.width = this.AfiliacionConfig.afiliacion.columnasAfiliacion;
      } else {
        console.log(window.screen.width)
        this.mobile = false;
        this.width = '12'
      }
      this.entidad = environment.entidad[this.actual].entidadNombre
      this.Afiliacion = new Afiliacion();
      this.generalModel = new general();
      this.campoFiltrada = new ciudades();
      this.Afiliacion.familiares = {}
      this.CargarAutorizacion();
    } else {
      this._router.navigate(['afiliacion']);
    }
  }

  FormularioAfiliacion() {
    this.spinner.show()
    this.Servicio.httpGet('getParamsAfiliacion/' + this.Servicio.GetsessionStorage).subscribe(
      (response: any) => {

        this.FormularioAfiliacionWeb = response.details

        this.grupoAsociados = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'BASICOS');
        this.grupoAsociados2 = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'BASICOS2');
        this.grupoLaboral = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'LABORAL');
        this.grupoFinanciera = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'FINANCIERA');
        this.grupoFamiliar = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'FAMILIAR');
        this.grupoReferenciaPer = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'REFERENCIAS PERSONALES');
        this.grupoReferenciaFam = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'REFERENCIAS FAMILIARES');
        this.grupoDocumentos = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'DOCUMENTOS');
        this.grupoAhorros = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'AHORROS');
        this.grupoAseguradora = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'ASEGURADORA');
        this.grupoBeneficiariosfalle = this.FormularioAfiliacionWeb.filter(item => item.NOMBREGRUPOCAMPO == 'BENEFICIARIOS FALLECIMIENTO');


        if (typeof this.grupoAsociados !== 'undefined' && this.grupoAsociados.length > 0) {
          this.grupos.push(this.grupoAsociados);
        }
        if (typeof this.grupoAsociados2 !== 'undefined' && this.grupoAsociados2.length > 0) {
          this.grupos.push(this.grupoAsociados2);
        }
        if (typeof this.grupoLaboral !== 'undefined' && this.grupoLaboral.length > 0) {
          this.grupos.push(this.grupoLaboral);
        }
        if (typeof this.grupoFinanciera !== 'undefined' && this.grupoFinanciera.length > 0) {
          this.grupos.push(this.grupoFinanciera);
        }

        if (typeof this.grupoReferenciaFam !== 'undefined' && this.grupoReferenciaFam.length > 0) {
          this.grupos.push(this.grupoReferenciaFam);
        }
        if (typeof this.grupoReferenciaPer !== 'undefined' && this.grupoReferenciaPer.length > 0) {
          this.grupos.push(this.grupoReferenciaPer);
        }
        if (typeof this.grupoFamiliar !== 'undefined' && this.grupoFamiliar.length > 0) {
          this.grupos.push(this.grupoFamiliar);
          this.grupoFamiliar.forEach(item => {
            this.attrFam.disabled.familiar1[item.NOMBRECAMPO] = item.DISABLEDCAMPO
          })
        }
        if (typeof this.grupoBeneficiariosfalle !== 'undefined' && this.grupoBeneficiariosfalle.length > 0) {
          this.grupos.push(this.grupoBeneficiariosfalle);
          this.grupoBeneficiariosfalle.forEach(item => {
            this.attrFam.disabled.beneficiario1[item.NOMBRECAMPO] = item.DISABLEDCAMPO
          })
        }
        if (typeof this.grupoDocumentos !== 'undefined' && this.grupoDocumentos.length > 0) {
          this.grupos.push(this.grupoDocumentos);
        }
        if (typeof this.grupoAhorros !== 'undefined' && this.grupoAhorros.length > 0) {
          this.grupos.push(this.grupoAhorros);
        }
        if (typeof this.grupoAseguradora !== 'undefined' && this.grupoAseguradora.length > 0) {
          this.grupos.push(this.grupoAseguradora);
        }



        this.FormularioAfiliacionWeb.forEach(element => {

          if (element.TIPOINPUTCAMPO == 'select' || element.TIPOINPUTCAMPO == 'option') {
            this.SelectDinamico(element.TABLAOPTION, element.ITEM1, element.ITEM2, element.ITEM3, element.NOMBRECAMPO);
          }

          if (this.entidad == 'Colaborar' || this.entidad == 'Fesfa' || this.entidad == 'Fedeaa') {
            if (element.NOMBREGRUPOCAMPO == 'FAMILIAR') {
              element.NOMBREGRUPOCAMPO = 'BENEFICIARIOS'
            }
          }
        });

        this.precarga()
      },
      error => {
        this.spinner.hide()
        console.log(error)
      }
    )
  }

  SelectDinamico($tabla, $item1, $item2, $item3, $campo) {
    this.generalModel.tabla = $tabla
    this.generalModel.item1 = $item1
    this.generalModel.item2 = $item2
    this.generalModel.item3 = $item3

    this.Servicio.httpPost('selectDinamico', this.generalModel).subscribe(
      response => {
        if ($tabla == 'OFICINAS') {
          this.oficinas = response
        } else {
          this.select[$campo] = response;

          if ($tabla == 'CIUDADES_V2') {
            for (let i = 0; i < this.select[$campo].length; i++) {
              this.select[$campo][i].DESCRIPCION = this.select[$campo][i].DESCRIPCION.split(' ')
              this.select[$campo][i].DESCRIPCION = this.normalize(this.select[$campo][i].DESCRIPCION[0])
            }
          }
        }

      },
      error => {
        console.log(<any>error);
      }
    );
  }

  CiudadesFiltro(campoS, valor, tipo, valid, campoN) {
    if (campoS != null && campoS != undefined) {
      if (campoS.toString().indexOf(';') >= 0) {
        this.camposSeparadosS = campoS.split(';');
      } else {
        this.camposSeparadosS.push(campoS);
      }
    }

    if (campoN != null && campoN != undefined) {
      if (campoN.toString().indexOf(';') >= 0) {
        this.camposSeparadosN = campoN.split(';');
      } else {
        this.camposSeparadosN.push(campoN);
      }
    }

    let tipos = []
console.log(tipo)
    if (tipo != null && tipo != undefined) {
      if (tipo.toString().indexOf(';') >= 0) {
        tipos = tipo.split(';');
      } else {
        tipos.push(tipo);
      }
    }

    for (let i = 0; i < tipos.length; i++) {
      switch (tipos[i]) {
        case 'FILTROSELECT':
          valor = valor.toUpperCase();
          this.campoFiltrada[campoS] = this.select[campoS].filter(item => {
            return item.DESCRIPCION.toLowerCase().indexOf(
              valor.toLowerCase()) > -1;
          });
          break;
        case 'DISABLEDCAMPO':
          if (valor.value == valid) {
            if (this.camposSeparadosS) {
              this.camposSeparadosS.forEach(camposSeparadosVS => {
                this.grupos.forEach(grupo => {
                  grupo.forEach(element => {
                    if (element.NOMBRECAMPO == camposSeparadosVS) {
                      element.DISABLEDCAMPO = 'false';
                    }
                  });
                });
              });
            }

            if (this.camposSeparadosN) {
              this.camposSeparadosN.forEach(camposSeparadosVN => {
                this.grupos.forEach(grupo => {
                  grupo.forEach(element => {
                    if (element.NOMBRECAMPO == camposSeparadosVN) {
                      element.DISABLEDCAMPO = 'true';
                    }
                  });
                });
              });
            }
          } else {
            if (this.camposSeparadosS) {
              this.camposSeparadosS.forEach(camposSeparadosVS => {
                this.grupos.forEach(grupo => {
                  grupo.forEach(element => {
                    if (element.NOMBRECAMPO == camposSeparadosVS) {
                      element.DISABLEDCAMPO = 'true';
                    }
                  });
                });
              });
            }
            if (this.camposSeparadosN) {
              this.camposSeparadosN.forEach(camposSeparadosVN => {
                this.grupos.forEach(grupo => {
                  grupo.forEach(element => {
                    if (element.NOMBRECAMPO == camposSeparadosVN) {
                      element.DISABLEDCAMPO = 'false';
                    }
                  });
                });
              });
            }
          }
          break;
        case 'REQUIREDCAMPO':
          valid = Number.parseInt(valid)
          console.log(valor, valid)
          if (valor == valid) {
            if (this.camposSeparadosS != undefined) {
              this.camposSeparadosS.forEach(camposSeparadosVS => {
                console.log(camposSeparadosVS)
                this.grupos.forEach(grupo => {
                  grupo.forEach(element => {
                    if (element.NOMBRECAMPO == camposSeparadosVS) {
                      console.log(element)
                      element.CAMPOREQUERIDO = 'TRUE';
                      console.log(element.CAMPOREQUERIDO, element.NOMBRECAMPO)
                    }
                  });
                });
              });
            }

            if (this.camposSeparadosN != undefined) {
              this.camposSeparadosN.forEach(camposSeparadosVN => {
                this.grupos.forEach(grupo => {
                  grupo.forEach(element => {
                    if (element.NOMBRECAMPO == camposSeparadosVN) {
                      element.CAMPOREQUERIDO = 'FALSE';
                    }
                  });
                });
              });
            }
          } else {

            if (this.camposSeparadosS != undefined) {
              this.camposSeparadosS.forEach(camposSeparadosVS => {
                this.grupos.forEach(grupo => {
                  grupo.forEach(element => {
                    if (element.NOMBRECAMPO == camposSeparadosVS) {
                      element.CAMPOREQUERIDO = 'FALSE';
                    }
                  });
                });
              });
            }
            if (this.camposSeparadosN != undefined) {
              this.camposSeparadosN.forEach(camposSeparadosVN => {
                this.grupos.forEach(grupo => {
                  grupo.forEach(element => {
                    if (element.NOMBRECAMPO == camposSeparadosVN) {
                      element.CAMPOREQUERIDO = 'TRUE';
                    }
                  });
                });
              });
            }
          }
          break;
        case 'TIPO_DOCUMENTO_ADJUNTO':
          for (let i = 1; i < this.grupoDocumentos.length; i++) {
            console.log('hola', i)
            this.grupos.forEach(grupo => {
              grupo.forEach(element => {
                if (element.NOMBRECAMPO == 'adjunto' + i) {
                  if (this.actual == 'cooptraconalvidrios' && element.NOMBRECAMPO != 'adjunto6') {
                    element.DISABLEDCAMPO = 'true';
                  } else if (this.actual != 'cooptraconalvidrios') {
                    element.DISABLEDCAMPO = 'true';
                  }
                }
              });
            });

          }
          let campo = ''
          switch (valor) {
            case 1:
              campo = 'adjunto1'
              break;
            case 2:
              campo = 'adjunto2'
              break;
            case 3:
              campo = 'adjunto5'
              break;
            case 4:
              campo = 'adjunto3'
              break;
            case 5:
              campo = 'adjunto4'
              break;

            default:
              break;
          }
          this.grupos.forEach(grupo => {
            grupo.forEach(element => {
              if (element.NOMBRECAMPO == campo) {
                element.DISABLEDCAMPO = 'false';
              }
            });
          });
          break;
        case 'DOCUMENTO_CAP_SOLIDARIA':
          this.grupos.forEach(grupo => {
            grupo.forEach(element => {
              if (element.NOMBRECAMPO == 'certcapsolidaria') {
                if (valor.value == valid) {
                  element.DISABLEDCAMPO = 'false';
                } else {
                  element.DISABLEDCAMPO = 'true';
                }
              }
            });
          });
          break;
        case 'OFIFONASBCOL':
          console.log(this.oficinas)
          console.log(valor)

          this.select['codofi'] = this.oficinas.filter(item => {
            return item.CODENT == valor
          });

          console.log(this.select['codofi'])
          break;

        default:
          break;
      }
    }
  }

  subida(event, NOMBRECAMPO) {
    console.log(event)
    console.log(this.Afiliacion)
    if (event.originalEvent.body) {
      if (event.originalEvent.body.status == 'success') {
        console.log(event.originalEvent.body)
        this.Afiliacion.documentos[NOMBRECAMPO] = event.originalEvent.body.filename
        this.messageService.add({ severity: 'success', summary: 'Success', detail: event.originalEvent.body.message });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: event.originalEvent.body.message });
      }
    }
  }

  precarga() {
    let data = {
      correo: this.Servicio.GetsessionStorage('email')
    }
    this.Afiliacion = new general()
    this.Servicio.httpPost('precargaAfil', data).subscribe(resp => {
      console.log(resp)
      this.spinner.hide()
      if (resp.details) {
        var d;
        var n;
        var i;
        console.log(resp)
        if (resp.details.fechaexp) {
          d = resp.details.fechaexp
          if (d.toString().indexOf(' ')) {
            let valor = d.split(' ');
            d = valor[0];
          }
          if (d.toString().indexOf('T')) {
            let valor = d.split('T');
            d = valor[0];
          }

          d = new Date(d + ' 11:00')

          this.fecexp = d.toISOString();
        }
        if (resp.details.fechanac) {
          n = resp.details.fechanac
          if (n.toString().indexOf(' ')) {
            let valor = n.split(' ');
            n = valor[0];
          }
          if (n.toString().indexOf('T')) {
            let valor = n.split('T');
            n = valor[0];
          }
          n = new Date(n + ' 11:00')
          this.fecnac = n.toISOString();
        }
        if (resp.details.fechaingempresa) {
          i = resp.details.fechaingempresa

          if (i.toString().indexOf(' ')) {
            let valor = i.split(' ');
            i = valor[0];
          }

          if (i.toString().indexOf('T')) {
            let valor = i.split('T');
            i = valor[0];
          }

          console.log(i)
          i = new Date(i + ' 11:00')

          this.fechaingempresa = i.toISOString();
        }

        if (resp.details) {
          this.Afiliacion = resp.details
        }

        if(this.Afiliacion.empresa){
          this.CiudadesFiltro("codnomina;", this.Afiliacion.empresa, "REQUIREDCAMPO;OFIFONASBCOL", "60", null)
        }
      }

      if(this.Afiliacion.familiares){
        Object.keys(this.Afiliacion.familiares).forEach(item => { this.agregarFamiliar(false) })
      }
      
      if(this.Afiliacion.beneficiarios){
        Object.keys(this.Afiliacion.beneficiarios).forEach(item => { this.agregarBeneficiarios(false) })
      }
      
      console.log(this.Afiliacion)

      if (typeof this.grupoDocumentos !== 'undefined' && this.grupoDocumentos.length > 0) {
        this.Afiliacion.documentos = {}
      }
    })
  }

  CargarAutorizacion() {
    let data = {
      autorizacion: "WEB_AUTORIZACION_AFILIACION"
    }
    this.Servicio.httpPost('cargaEntidad', data).subscribe(
      response => {
        this.autorizacion = response['WEBAUTORIZACION'];
        this.FormularioAfiliacion();
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  guardar(forma, valid) {
    console.log(this.Afiliacion)
    if (valid) {
      if (this.Afiliacion.Acepto == 'S') {
        this.spinner.show();
        console.log(this.Afiliacion)
        if (this.Afiliacion.familiares) {
          if (this.Afiliacion.familiares.length > 0) {
            for (let i = 0; i < this.Afiliacion.familiares.length; i++) {
              delete this.Afiliacion.familiares['familiar' + i].REQUIRED
            }
          }
        }
        if (this.Afiliacion.beneficiarios) {
          if (this.Afiliacion.beneficiarios.length > 0) {
            for (let i = 0; i < this.Afiliacion.beneficiarios.length; i++) {
              delete this.Afiliacion.beneficiarios['beneficiario' + i].REQUIRED
            }
          }
        }
        let cont = 0;
        Object.keys(this.Afiliacion).forEach(resp => {
          cont = cont + 1
        })

        if (cont > 0) {
          this.Servicio.getIPAddress().subscribe((res: any) => {
            this.Afiliacion.ip = res.ip;
            this.Servicio.httpPost('guardaAfiliacion', this.Afiliacion).subscribe(response => {
              if (response.status == 'success') {
                Swal.fire({
                  icon: 'success',
                  title: 'Proceso Exitoso!',
                  text: 'Los cambios se han enviado al administrador pendientes por ser aprobados',
                  showConfirmButton: false,
                  timer: 5000
                });
                this._router.navigate(['afiliacion'])
                localStorage.clear();
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error al actualizar',
                  text: 'Comuniquese con el administrador',
                })
              }
              this.spinner.hide()
            }, error => {
              console.log(error)
              this.spinner.hide()
            })
          })
        } else {
          this.spinner.hide()
          Swal.fire({
            icon: 'error',
            title: 'Error al actualizar',
            text: 'No se han llenado los datos',
          })
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al actualizar',
          text: 'Por favor lea y acepte las autorizaciones para continuar',
        })
      }
    }
  }

  insertarDireccion(nombreCampo, fam) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '60%';
    const modalRef = this.dialog.open(DireccionesComponent, {
      autoFocus: false,
      maxHeight: '80vh' //you can adjust the value as per your view
    });
    modalRef.afterClosed().subscribe(res => {
      console.log(res)

      if (res.dir != null && res.dir != undefined && res.dir != 'undefined' && res.dir != false) {

        if (fam == 0) {
          this.grupos.forEach(grupo => {
            grupo.forEach(element => {
              if (element.NOMBRECAMPO == nombreCampo) {
                this.Afiliacion[element.NOMBRECAMPO] = res.dir;
              }
            });
          });
        } else {
          this.Afiliacion.familiares['familiar' + fam][nombreCampo] = res.dir;
        }
      }
    })
  }

  agregarFamiliar(nuevo: boolean) {
    let num = this.familiares.length
    if (nuevo) {

    } else {

    }
    if (num > 0) {
      num = num + 1
      if (nuevo) {
        this.Afiliacion.familiares['familiar' + num] = { REQUIRED: 'REQUIRED' }
      }
      this.familiares.push(num)
    } else {
      num = num + 1
      if (nuevo) {
        this.Afiliacion.familiares = {}
        this.Afiliacion.familiares['familiar' + num] = { REQUIRED: 'REQUIRED' }
      }
      this.familiares.push(num)
    }
    this.attrFam.disabled['familiar' + num] = {
      NITRESPONSABLE: 'true',
      CELULARRESPONSABLE: 'true',
      CODPARENTESCO: 'false',
      APELLIDOS: 'false',
      TIPONIT: 'false',
      PORCENTAJE: 'false',
      CODNIVELESCOLARIDAD: 'false',
      NIT: 'false',
      NOMBRES: 'false',
      FHANACIMIENTO: 'false',
      APELLIDOSRESPONSABLE: 'true',
      NOMBRESRESPONSABLE: 'true'
    }
    if (this.AfiliacionConfig.actualizacion.actPrFam == 'S') {
      if (this.familiares.length > 1) {
        this.remove = true;
      } else {
        this.remove = false;
      }
    } else {
      this.remove = true;
    }
  }

  agregarBeneficiarios(nuevo: boolean) {
    let num = this.beneficiarios.length
    if (num > 0) {
      num = num + 1
      if (nuevo) {
        this.Afiliacion.beneficiarios['beneficiario' + num] = { REQUIRED: 'REQUIRED' }
      }
      this.beneficiarios.push(num)
    } else {
      num = num + 1
      if (nuevo) {
        this.Afiliacion.beneficiarios = {}
        this.Afiliacion.beneficiarios['beneficiario' + num] = { REQUIRED: 'REQUIRED' }
      }
      this.beneficiarios.push(num)
    }

    console.log(this.Afiliacion.beneficiarios)
    this.attrFam.disabled['beneficiario' + num] = this.attrFam.disabled.beneficiario1
    if (this.AfiliacionConfig.actualizacion.actPrFam == 'S') {
      if (this.beneficiarios.length > 1) {
        this.remove = true;
      } else {
        this.remove = false;
      }
    } else {
      this.remove = true;
    }
  }

  removerFamiliar() {
    this.familiares.pop()
    let cont = Object.getOwnPropertyNames(this.Afiliacion.familiares)
    delete this.Afiliacion.familiares['familiar' + cont.length]
    if (this.AfiliacionConfig.actualizacion.actPrFam == 'S') {
      if (this.familiares.length >= 2) {
        this.remove = true;
      } else {
        this.remove = false;
      }
    }
  }

  removerBeneficiarios() {
    this.beneficiarios.pop()
    let cont = Object.getOwnPropertyNames(this.Afiliacion.beneficiarios)
    delete this.Afiliacion.beneficiarios['beneficiario' + cont.length]
    if (this.AfiliacionConfig.actualizacion.actPrFam == 'S') {
      if (this.familiares.length >= 2) {
        this.remove = true;
      } else {
        this.remove = false;
      }
    }
  }



  normalize = (function () {
    var from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
      to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
      mapping = {};

    for (var i = 0, j = from.length; i < j; i++)
      mapping[from.charAt(i)] = to.charAt(i);

    return function (str) {
      var ret = [];
      for (var i = 0, j = str.length; i < j; i++) {
        var c = str.charAt(i);
        if (mapping.hasOwnProperty(str.charAt(i)))
          ret.push(mapping[c]);
        else
          ret.push(c);
      }
      return ret.join('');
    }

  })();
}
